import { render, staticRenderFns } from "./Fednet.vue?vue&type=template&id=6d113305&scoped=true"
import script from "./Fednet.vue?vue&type=script&lang=js"
export * from "./Fednet.vue?vue&type=script&lang=js"
import style0 from "./Fednet.vue?vue&type=style&index=0&id=6d113305&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d113305",
  null
  
)

export default component.exports